// extracted by mini-css-extract-plugin
export default {"card":"UserCardImage_card__rSfTx","avatar":"UserCardImage_avatar__YIY+X","action":"UserCardImage_action__+sGnC"};